import { Component, OnInit, OnDestroy, inject, signal } from '@angular/core';

import { PartTypeGridComponent } from '../parts/part-type-grid.component';
import { FiltersComponent } from './filters.component';
import { PartTabsComponent } from '../parts/part-tabs.component';
import { SliderComponent } from './slider.component';
import { Part } from '../core/models/part';
import { PartsService } from '../core/parts.service';
import { ApplicationInfoService } from '../core/application-info.service';

const TESTIMONIALS = [
    {
        quote: `"Deserve more than 5 ! These guys always go above and beyond in helping us. Great prices quality parts and all around great service! Thank y'all from Eric and I, for helping us time and time again. Definitely recommend!"`,
        author: 'April Mullen'
    },
    {
        quote: `"I was hesitant to buy aftermarket engine parts from an unknown source but after talking to a real person on the phone was convinced to give it a chance. My order was shipped the same day and arrived in perfect condition. Everything is of excellent quality and fits perfectly. Thank you for being knowledgeable and doing you what you said you would do."`,
        author: 'Thomas Hedglin'
    },
    {
        quote: `"Guys are very knowledgeable about the motors they sell and excellent prices. Want to send a thank you for having a motor for our Peterbilt will be using again in the future."`,
        author: 'James Tandy'
    },
    {
        quote: `"Turn key diesel engine parts, great inventory."`,
        author: 'Paul Elenbaas'
    },
    {
        quote: `"Kudos to these guys. Ordered a older part, got it and it was just as they presented it. Shipping was pain free as well. HIGHLY RECOMMEND THESE PEOPLE."`,
        author: 'Jeffery Pate'
    },
    {
        quote: `"Tim and his guys are very knowledgeable and helpful and almost always have what we need. Thanks and keep up the good work."`,
        author: 'Jack Brands'
    }
];

const FAQS = [
    {
        q: 'What types of diesel motor parts do you offer?',
        a: 'Among diesel motor parts, we have engines, injectors, filters, and more. Our huge selection is meant to satisfy different makes and models, therefore guaranteeing you will discover the correct components for your particular requirement.'
    },
    {
        q: 'Can I find used diesel parts on your website?',
        a: 'Yes, we have a range of premium secondhand diesel components available that offer a reasonably priced substitute without sacrificing performance. Before being included, every component is painstakingly checked to satisfy strict criteria.'
    },
    {
        q: 'How do I know the parts I purchase are compatible with my engine?',
        a: 'Our product descriptions include detailed specifications and model compatibility. Our knowledgeable customer service staff is here to assist you to make sure you acquire the right engine component should you need further support.'
    },
    {
        q: 'Do you offer warranties on your diesel parts?',
        a: 'Yes, we provide warranties on both new and used diesel parts. The warranty length and coverage details vary by part type and condition, ensuring you receive support and assurance with every purchase.'
    },
    {
        q: 'What support do you offer if I encounter issues with the part I purchased?',
        a: 'Our team of professionals is available to help you with any queries or problems. If necessary, we may aid with returns or exchanges; we provide installation instructions and technical support. Get direct help from us.'
    }
];

@Component({
    selector: 'app-home',
    template: `
        @if (appInfo.isPPM()) {
            <div class="master-column-wrapper">
                <div class="ppm-home-intro">
                    <h1><strong>Power Play Products</strong></h1>
                    <p>Welcome to <strong>Power Play Products</strong></p>
                </div>
            </div>
        }

        <div class="slider-wrap">
            <app-slider />
        </div>

        @if (!appInfo.isPPM()) {
            <div class="home-filters">
                <app-filters />
            </div>
        }

        <div class="home-products-section" [class.ppm-layout]="appInfo.isPPM()">
            <app-part-type-grid />
            <div class="master-column-wrapper home-page">
                <app-part-tabs [parts]="parts()" [pageSize]="8" />
            </div>
        </div>

        @if (!appInfo.isPPM()) {
            <div class="reviews-section">
                <div class="">
                    <!-- <div class="google-reviews"> -->

                    <div class="master-column-wrapper testimonials">
                        <div class="testimonial-wrapper">
                            <button class="testimonial-arrow prev" (click)="prevPage()" aria-label="Previous">&#10094;</button>
                            <div class="testimonial-track">
                                @for (t of visibleTestimonials(); track t.author) {
                                    <div class="testimonial-card">
                                        <img src="/assets/images/5-stars-300x58.png" alt="5 stars" width="100" height="19" />
                                        <p>{{ t.quote }}</p>
                                        <strong>{{ t.author }}</strong>
                                    </div>
                                }
                            </div>
                            <button class="testimonial-arrow next" (click)="nextPage()" aria-label="Next">&#10095;</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="master-column-wrapper">
                <div class="home-intro">
                    <h1>Diesel Parts</h1>
                    <h2>Quality and Affordability: The North American Diesel Parts Promise</h2>
                    <p>
                        At North American Diesel Parts, we've built our reputation on providing top-tier diesel engine parts, used diesel
                        parts, and comprehensive diesel parts sales since our founding. Our journey from a small team with limited inventory
                        to an industry leader offering over 1,000 core engines and 150 new aftermarket products reflects our commitment to
                        meeting the evolving needs of our customers. Whether you're a truck owner, fleet manager, or expert technician, our
                        extensive catalog of high-quality components &#8211; each meticulously inspected to meet rigorous industry standards
                        &#8211; ensures you'll find the perfect solution for your diesel engine needs. We understand the importance of both
                        performance and affordability, which is why we offer premium diesel engine parts for those seeking top performance
                        and reliable used diesel parts for cost-effective repairs. Our user-friendly website, designed with your convenience
                        in mind, provides access to a wide range of online diesel parts, making it easy for you to find and purchase the
                        right components. At North American Diesel Parts, we're not just selling parts; we're providing solutions that
                        extend the life of your diesel engines, keeping you moving forward with confidence.
                    </p>
                </div>
            </div>

            <div class="master-column-wrapper">
                <div class="seo-columns">
                    <div class="seo-col">
                        <h2>Quality Diesel Engine Parts for Performance and Durability</h2>
                        <p>
                            Welcome to North American Diesel Parts, where automotive industry dependability meets excellence. We are
                            committed to providing you with the best Diesel Motors Parts and Used Diesel Parts available. Our large catalog
                            guarantees that you will find right what you need to maintain the effective operation of your diesel engines.
                        </p>
                        <p>
                            We have you covered whether your needs are for reasonably priced Used Diesel components for repairs or strong
                            Diesel motor components to improve performance. Our choice of components, each painstakingly inspected to
                            satisfy high industry standards, reflects our dedication to quality.
                        </p>
                        <p>
                            Using our website is simple, created with you in mind to guarantee a perfect buying experience. From thorough
                            product descriptions to professional client support, we are here to help you at every level. Trust us to provide
                            not just components but also solutions that extend the lifetime of your diesel engines.
                        </p>
                        <p>
                            With our superior Diesel Motors Parts, review the possibilities for your gear; alternatively, save money without
                            sacrificing quality with our trusted Used Diesel Parts. Maintaining your diesel engines with the finest products
                            is important, and at North American Diesel Parts, we know this.
                        </p>
                        <p>
                            Explore our diesel parts to see how we could enable you to move forward confidently. We appreciate you looking
                            to us as your reliable diesel engine maintenance and repair partner.
                        </p>
                    </div>
                    <div class="seo-col">
                        <h2>Superior Diesel Parts for Every Vehicle at Reasonably Prices</h2>
                        <p>
                            Welcome to North American Diesel Parts, your reliable supplier of superior diesel parts available throughout
                            North America. Whether your job is truck owner, fleet manager, or expert technician, our large collection of
                            Diesel Parts Sales ensures you will discover just what you need. Having years of experience in the field, we
                            take great satisfaction in offering dependable and strong components meant to keep your diesel cars operating
                            effectively and without problems.
                        </p>
                        <p>
                            Customer satisfaction is the first concern at North American Diesel Parts. We guarantee you the correct
                            component when you most need it by means of speedy shipment and outstanding service. Our experienced staff is
                            available to help with any queries about our Diesel Parts Sales, therefore enabling you to choose the best
                            option for the performance and lifetime of your vehicle.
                        </p>
                        <p>
                            Discover filters, injectors, pumps, and much more among our wide selection of Diesel Parts Sales. Count on our
                            premium products to keep your car running for more years with less downtime and fewer repairs.
                        </p>
                        <p>Browse our entire inventory and discover the difference in diesel parts now at North American Diesel Parts.</p>
                    </div>
                </div>

                <div class="faq-section">
                    <h2>FAQs</h2>
                    @for (faq of faqs; track faq.q; let i = $index) {
                        <div class="faq-item" [class.open]="openFaqs().has(i)" (click)="toggleFaq(i)">
                            <span class="faq-question">{{ faq.q }}</span>
                            <span class="faq-icon">{{ openFaqs().has(i) ? '−' : '+' }}</span>
                            @if (openFaqs().has(i)) {
                                <div class="faq-answer">{{ faq.a }}</div>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    `,
    styles: `
        :host {
            display: block;
            color: #333;
        }

        h1,
        h2 {
            font-family: var(--main-font-family), Helvetica, Arial, Lucida, sans-serif;
            font-weight: 600;
            color: #333;
        }

        p {
            font-family: Arial, Helvetica, sans-serif;
            font-size: 14px;
            color: #333;
            line-height: 1.7em;
            margin-bottom: 1em;
        }

        /* ── Slider top spacing ── */
        .slider-wrap {
            margin-top: 20px;
        }

        /* ── Products section (full-width, no master-column-wrapper constraint) ── */
        .home-products-section {
            padding: 0 0 30px;

            &.ppm-layout {
                padding-top: 20px;
            }
        }

        /* ── Intro ── */
        .ppm-home-intro {
            text-align: left;
            padding: 35px 0 1px;

            h1 {
                font-size: 30px;
                line-height: 1.3em;
                margin-bottom: 0.5rem;
            }

            h2 {
                font-size: 22px;
                line-height: 1.2em;
                margin-bottom: 1rem;
            }

            p {
                font-size: 25px;
            }
        }

        .home-intro {
            text-align: center;
            padding: 60px 0 30px;

            h1 {
                font-size: 30px;
                font-weight: 500;
                line-height: 1.3em;
                margin-bottom: 0.5rem;
            }

            h2 {
                font-size: 22px;
                font-weight: 400;
                line-height: 1.2em;
                margin-bottom: 1rem;
            }

            p {
                font-size: 16px;
            }
        }

        .home-filters {
            background-color: #fff;
            padding-top: 30px;
            margin-bottom: 30px;
        }

        /* ── Reviews ── */
        .reviews-section {
            background-image: url('https://nadieselparts.com/wp-content/uploads/2024/06/image_2024-06-13_024253727.png');
            background-position: center top;
            background-repeat: no-repeat;
            background-size: cover;
            padding: 25px 0 32px;
        }

        /* ── Testimonials ── */
        .testimonials {
            padding: 1rem 0 1rem;
        }

        .testimonial-wrapper {
            position: relative;
        }

        .testimonial-arrow {
            background: none;
            border: none;
            font-size: 36px;
            color: #333;
            cursor: pointer;
            padding: 0;
            line-height: 1;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 2;
        }

        .testimonial-arrow.prev {
            left: -40px;
        }

        .testimonial-arrow.next {
            right: -40px;
        }

        .testimonial-track {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 10px;
        }

        @media (max-width: 768px) {
            .testimonial-track {
                grid-template-columns: 1fr;
            }

            .testimonial-arrow.prev {
                left: 0;
            }

            .testimonial-arrow.next {
                right: 0;
            }
        }

        @media (min-width: 769px) and (max-width: 1024px) {
            .testimonial-track {
                grid-template-columns: repeat(2, 1fr);
            }
        }

        .testimonial-card {
            background-color: #f4f4f4;
            border: 1px solid #d8d8d8;
            border-radius: 3px;
            padding: 15px;
            text-align: center;

            img {
                margin-bottom: 0.75rem;
            }

            p {
                font-style: italic;
                margin-bottom: 0.75rem;
            }
        }

        /* ── SEO columns ── */
        .seo-columns {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 2rem;
            padding: 2rem 0;
            text-align: left;

            h2 {
                font-size: 26px;
                font-weight: 500;
                margin-bottom: 1rem;
            }

            p {
                font-size: 16px;
            }
        }

        /* ── FAQs ── */
        .faq-section {
            padding: 1rem 0 3rem;
            max-width: 700px;
            margin-left: auto;
            margin-right: auto;

            h2 {
                font-family: Arial, Helvetica, sans-serif;
                font-size: 26px;
                font-weight: 500;
                text-align: center;
                margin-bottom: 2.5rem;
            }
        }

        .faq-item {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            background: #f6f6f6;
            border: 1px solid #e0e0e0;
            border-radius: 3px;
            padding: 12px 18px;
            margin-bottom: 25px;
            cursor: pointer;
            user-select: none;
        }

        .faq-question {
            flex: 1;
            font-family: Helvetica, Arial, Lucida, sans-serif;
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            line-height: 1.5;
        }

        .faq-icon {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 2px solid #aaa;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.85rem;
            font-weight: 400;
            color: #aaa;
            flex-shrink: 0;
            margin-left: 1rem;
            line-height: 1;
        }

        .faq-answer {
            width: 100%;
            padding: 10px 0 4px;
            font-family: Arial, Helvetica, sans-serif;
            font-size: 15px;
            color: #333333;
            line-height: 1.7em;
        }

        @media (max-width: 768px) {
            .seo-columns {
                grid-template-columns: 1fr;
                padding: 1rem 16px;
            }

            .home-intro {
                padding: 40px 16px 20px;
            }

            .faq-section {
                padding: 1rem 16px 3rem;
            }
        }
    `,
    imports: [PartTypeGridComponent, FiltersComponent, PartTabsComponent, SliderComponent]
})
export class HomeComponent implements OnInit, OnDestroy {
    appInfo = inject(ApplicationInfoService);
    partsService = inject(PartsService);
    parts = signal<Part[]>([]);

    faqs = FAQS;

    readonly PAGE_SIZE = 3;
    testimonialPage = signal(0);
    testimonialPages = signal(Array.from({ length: Math.ceil(TESTIMONIALS.length / this.PAGE_SIZE) }, (_, i) => i));
    visibleTestimonials = signal(TESTIMONIALS.slice(0, this.PAGE_SIZE));

    openFaqs = signal<Set<number>>(new Set());

    private carouselTimer?: ReturnType<typeof setInterval>;

    async ngOnInit() {
        if (this.appInfo.isPPM()) {
            this.appInfo.setTitle('Shop Power Play Products');
            this.appInfo.setMeta('description', 'Shop high-quality manifolds. Find reliable manifolds at Power Play Products.');
        } else {
            this.appInfo.setTitle('Shop Diesel Engine Parts - Cummins, Caterpillar & More');
            this.appInfo.setMeta(
                'description',
                'Shop high-quality diesel engine parts for Cummins, Caterpillar, and Detroit engines. Find reliable parts for your diesel engine at NADieselParts.'
            );
            this.startCarousel();
        }

        const parts = await this.partsService.getParts({ hasPictures: true, isFeatured: true, hasPrice: true, take: 8 });
        this.parts.set(parts);
    }

    ngOnDestroy() {
        clearInterval(this.carouselTimer);
    }

    goToPage(index: number) {
        this.testimonialPage.set(index);
        const start = index * this.PAGE_SIZE;
        this.visibleTestimonials.set(TESTIMONIALS.slice(start, start + this.PAGE_SIZE));
    }

    prevPage() {
        const prev = (this.testimonialPage() - 1 + this.testimonialPages().length) % this.testimonialPages().length;
        this.goToPage(prev);
    }

    nextPage() {
        const next = (this.testimonialPage() + 1) % this.testimonialPages().length;
        this.goToPage(next);
    }

    toggleFaq(index: number) {
        const current = new Set(this.openFaqs());
        current.has(index) ? current.delete(index) : current.add(index);
        this.openFaqs.set(current);
    }

    private startCarousel() {
        this.carouselTimer = setInterval(() => {
            const next = (this.testimonialPage() + 1) % this.testimonialPages().length;
            this.goToPage(next);
        }, 10000);
    }
}
